module.exports = __webpack_public_path__ + "img/back-1-n-5715cf4f.png";